import { Box, Button, IconButton, Modal } from '@material-ui/core'
import ListSubheader from '@material-ui/core/ListSubheader'
import ListItemText from '@material-ui/core/ListItemText'
import ListItem from '@material-ui/core/ListItem'
import CancelIcon from '@material-ui/icons/Cancel'
import { useDispatch } from 'react-redux'
import { Doc, TrackingRows } from '@types'
import List from '@material-ui/core/List'
import { Add as AddIcon, InsertDriveFile as DocumentIcon } from '@material-ui/icons'
import { useState } from 'react'
import { useSnackbar } from 'notistack'
import EditFileCollapse from '@views/tracking/components/EditFileCollapse'
import { patchRecoveredRejectedInfo } from './state/analystRejectedSlice'

interface Props {
  row: TrackingRows
}

const DocumentModal: React.FC<Props> = ({ row }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [files, setFiles] = useState(row.files)
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()

  const openModal = () => {
    setIsOpen(true)
    setFiles(row.files)
  }

  const onCancel = () => {
    setIsOpen(false)
    setFiles(row.files)
  }

  const saveFiles = () => {
    dispatch(
      patchRecoveredRejectedInfo({
        files: files.map((file: Doc) => ({ name: file.name, link: file.link })),
        userId: row.id
      })
    )
    enqueueSnackbar('Cambios guardados', { variant: 'success' })
    setIsOpen(false)
  }

  const removeFile = (i: number) => {
    const filesCopy = [...files]
    filesCopy.splice(i, 1)
    setFiles(filesCopy)
  }

  return (
    <>
      <DocumentIcon
        style={{
          color: 'rgb(255, 105, 0)',
          width: '20px',
          height: '20px',
          margin: '0 10px',
          cursor: 'pointer'
        }}
        onClick={() => openModal()}
      />
      <Modal open={isOpen} onClose={() => setIsOpen(false)} className="documents-modal">
        <div
          style={{
            width: '600px',
            height: 'auto',
            background: 'white',
            borderRadius: '20px',
            paddingBottom: '10px',
            position: 'relative'
          }}
        >
          <IconButton
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px'
            }}
            onClick={onCancel}
          >
            <CancelIcon style={{ color: '#fc6404' }}></CancelIcon>
          </IconButton>
          <div
            style={{
              width: '100%',
              height: '40px',
              textAlign: 'center'
            }}
          >
            <h2
              style={{
                color: '#fc6404'
              }}
            >
              Documentos
            </h2>
          </div>
          <Box width="580px" bgcolor="white" padding="10px">
            <List
              component="nav"
              aria-labelledby="nested-list-subheader"
              subheader={
                <ListSubheader
                  component="div"
                  style={{
                    color: '#6c757d',
                    borderBottom: '2px solid #ff6900',
                    height: '40px',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center'
                  }}
                  id="nested-list-subheader"
                >
                  <IconButton
                    style={{
                      color: '#ff6900',
                      width: '10px',
                      height: '10px',
                      margin: '0 10px'
                    }}
                    onClick={() => {
                      setFiles(prev => [...prev, { _id: `new-${prev.length}`, name: '', link: '' }])
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                </ListSubheader>
              }
              style={{
                width: '100%'
              }}
            >
              <div
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'start',
                  maxHeight: '80vh',
                  overflow: 'hidden auto'
                }}
              >
                <ListItem>
                  <Box lineHeight="normal" width="100%">
                    <a className="anchor-bar" href={row.bankDocument} target="_blank" rel="noreferrer">
                      {'[Extracto]'}
                    </a>
                  </Box>
                </ListItem>
                {row.files.length === 0 && (
                  <ListItem
                    style={{
                      width: '100%'
                    }}
                  >
                    <ListItemText style={{ color: '#6c757d' }} primary="Sin documentos" />
                  </ListItem>
                )}

                {files.map((file, i) => (
                  <ListItem
                    key={i}
                    style={{
                      flexDirection: 'column',
                      width: '100%'
                    }}
                  >
                    <EditFileCollapse
                      isEditEnable={true}
                      name={file.name}
                      link={file.link}
                      isNew={file._id?.includes('new-')}
                      setName={name =>
                        setFiles(prev => prev.map(item => (item._id === file._id ? { ...item, name } : item)))
                      }
                      setLink={link =>
                        setFiles(prev => prev.map(item => (item._id === file._id ? { ...item, link } : item)))
                      }
                      onDelete={() => removeFile(i)}
                    />
                  </ListItem>
                ))}
                <Box
                  display="grid"
                  alignItems="center"
                  justifyContent="center"
                  width="100%"
                  gridTemplateColumns="35% 35%"
                  gridGap="5%"
                  gridTemplateRows="100%"
                  marginTop="20px"
                  marginBottom="10px"
                >
                  <Button type="button" variant="contained" color="inherit" onClick={onCancel}>
                    Cancelar
                  </Button>
                  <Button type="button" variant="contained" color="primary" onClick={saveFiles}>
                    Guardar
                  </Button>
                </Box>
              </div>
            </List>
          </Box>
        </div>
      </Modal>
    </>
  )
}

export default DocumentModal
